import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconArrowUp: OSKIconDefinition = {
  name: 'arrow-up',
  content: '<path d="m5 12 7-7 7 7" /><path d="M12 19V5" />'
};
